import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";

const PartnersSlider = () => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay:true,
    responsive: [
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2
        }
      },
      // {
      //   breakpoint: 768,
      //   settings: {
      //     slidesToShow: 1
      //   }
      // }
    ]
  };

  return (
    <main>
    <h1 className="text-center">Our Partners</h1>
    <Slider style={{margin: 'auto'}}  {...settings} >
        <div>
             <img className="carousel-image" src="img/partners/undp-logo.jpg" />    
        </div>
        <div>
            <img className="carousel-image"style={{maxWidth: '200px'}}  src="img/partners/giz-logo.png" />
        </div>
        <div> 
            <img className="carousel-image"  src="img/partners/european-union-logo.jpg" />   
        </div>
        <div> 
            <img className="carousel-image"  src="img/partners/stg-logo.png" />   
        </div>
        <div> 
            <img className="carousel-image"  src="img/partners/phgex-logo.png" />   
        </div>
        <div> 
            <img className="carousel-image"  src="img/partners/community-connect-logo.jpg" />   
        </div>
    </Slider>
</main>
  )
}

export default PartnersSlider